import { render, staticRenderFns } from "./ButtonPictures.vue?vue&type=template&id=68b1ab68&"
import script from "./ButtonPictures.vue?vue&type=script&lang=ts&"
export * from "./ButtonPictures.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonPictures.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports